module.exports = __webpack_public_path__ + "img/business_27.1cde8f20.jpg";